import React, { useContext, useState } from "react";
import "../Footer/footer.css";
import logo from "../images/logo.png";
import Social from "../Home/Social";
import LightModeIcon from "@mui/icons-material/LightMode";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import { DataContext } from "../contextAPI";
const Footer = () => {
  const { toggleMode, setToggleMode } = useContext(DataContext);

  return (
    // <div classNameName="footer-container">
    <footer className="footer-distributed">
      <div className="footer-left">
        <img
          classNameName="logo-text"
          src={logo}
          alt="Reham's logo "
          width="200"
          height="50"
        />

        <p className="footer-links">
          <a href="#Home">Home</a>

          <a href="#About">About</a>

          <a href="#Skills">Skills</a>

          <a href="#Services">Projects</a>

          <a href="#Contact">Contact</a>
          <div style={{ margin: "1rem 0" }}>
            {toggleMode ? (
              <LightModeIcon
                onClick={() => setToggleMode(false)}
                sx={{
                  fontSize: "30px",
                  cursor: "pointer",
                }}
              />
            ) : (
              <Brightness4Icon
                onClick={() => setToggleMode(true)}
                sx={{ fontSize: "30px", cursor: "pointer" }}
              />
            )}
          </div>
        </p>

        <p className="footer-company-name">© About 2024 Privacy Policy</p>
      </div>

      <div className="footer-center">
        <div>
          <i className="fa fa-map-marker"></i>
          <p>
            <span>Oman,Muscat</span>
          </p>
        </div>

        <div>
          <i className="fa fa-envelope"></i>
          <p>
            <a href="mailto:support@company.com">rehamcoder@gmail.com</a>
          </p>
        </div>
      </div>

      <div className="footer-right">
        <p className="footer-company-about">
          <span>About Me</span>
          Frontend developer and UI/UX enthusiast passionate about crafting
          immersive digital experiences. Specializing in intuitive interfaces,
          merging technology with creativity for impactful solutions.
        </p>

        <div style={{ marginTop: "12px" }}>
          <Social />
        </div>
      </div>
    </footer>
    // </div>
  );
};

export default Footer;
